import { render, staticRenderFns } from "./FeedbackTasks.vue?vue&type=template&id=30df00ae&scoped=true"
import script from "./FeedbackTasks.vue?vue&type=script&lang=ts"
export * from "./FeedbackTasks.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackTasks.vue?vue&type=style&index=0&id=30df00ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30df00ae",
  null
  
)

export default component.exports